import React, { useState } from 'react';
import Hero from '../components/home/Hero';
import CustomerLogos from '../components/home/CustomerLogos';
import FeatureCards from '../components/home/FeatureCards';
import WhyCustMax from '../components/home/WhyCustMax';
import Features from '../components/home/Features';
import CustomerStory from '../components/home/CustomerStory';
import FinalCTA from '../components/home/FinalCTA';
import AuthModal from '../components/auth/AuthModal';
import RegisterForm from '../components/auth/RegisterForm';

const HomePage = () => {
  const [showRegisterModal, setShowRegisterModal] = useState(false);

  return (
    <div>
      <Hero onTryFree={() => setShowRegisterModal(true)} />
      <CustomerLogos />
      <FeatureCards />
      <WhyCustMax />
      <Features />
      <CustomerStory />
      <FinalCTA />

      <AuthModal
        isOpen={showRegisterModal}
        onClose={() => setShowRegisterModal(false)}
        title="Create Your Account"
      >
        <RegisterForm onClose={() => setShowRegisterModal(false)} />
      </AuthModal>
    </div>
  );
};

export default HomePage;